/**
 * Constants for sidebar width values
 */
export const SIDEBAR_COLLAPSED_WIDTH = 80;
export const SIDEBAR_EXPANDED_WIDTH = 280;

/**
 * Utility function to get sidebar width with px suffix
 */
export const getSidebarWidthPx = (isCollapsed: boolean): string => {
	return `${isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH}px`;
};

/**
 * Utility function to get sidebar width as number
 */
export const getSidebarWidth = (isCollapsed: boolean): number => {
	return isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_EXPANDED_WIDTH;
};
